"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var ServiceDelivery = tslib_1.__importStar(require("./service-delivery"));
var init = function (hostname) {
    return {
        ServiceDelivery: ServiceDelivery.init(hostname)
    };
};
exports["default"] = {
    init: init
};
//# sourceMappingURL=index.js.map